import { render, staticRenderFns } from "./DashboardSettingsBillingCollectionItems.vue?vue&type=template&id=df694780&"
import script from "./DashboardSettingsBillingCollectionItems.vue?vue&type=script&lang=ts&"
export * from "./DashboardSettingsBillingCollectionItems.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports